/* eslint-disable no-eval */
import React from "react";
import { Form, Button, Table, Modal, Tooltip } from "antd";
import { PlusCircleOutlined, MessageOutlined } from "@ant-design/icons";
import i18next from "i18next"
import { camelCaseToTitle } from '../../helpers/StringHelper';
import {
  getFormTitles,
  getInputHeadLines,
  getInputLabel,
  getInputProp,
  getSubtitles,
  inputOnBlur,
  inputTypeComponent,
  showHideInput,
} from "./helper";
import { BasicInput } from '../ViewCADD/components/input';
import { propHasValue } from "../../components/DynamicFormNew/helper";
import { renderRepeatable as editRenderRepeatable } from '../Edit/RenderForm';
import { checkCondition } from './helper';
import dayjs from "dayjs";
import { ModalHeader, MoreMenu } from "datastake-daf/dist/components";
import { getLocales } from "../../components/Table/newTable";

const editRepeatableTemplates = [
  'DOCUMENTS_LOCATIONS',
  'DOCUMENTS_STAKEHOLDERS',
  'EDIT_REPEATABLE',
];

// options, k, setValues, values, excludedKeys, i, formTitles, getData, MainForm, plainForms, setAddress
export function renderNestedInputs(options, k, ...args) {
  if (options[k].repeatable) {
    if (options[k].template) {
      if (editRepeatableTemplates.includes(options[k].template)) {
        return editRenderRepeatable(options, k, ...args);
      }
    }
    return renderRepeatable(options, k, ...args);
  } else {
    return renderGroupOfInputs(options, k, ...args);
  }
}

export function renderRepeatable(options, k, setValues, values, excludedKeys, i, formTitles, getData, MainForm, plainForms, setAddress, currentField, setCurrentField, isModalVisible, setIsModalVisible) {
  const form = options[k];
  const formId = form.dataId || k;
  const allInputs = Object.keys(form.inputs).filter(i => {
    const input = form.inputs[i];
    return !excludedKeys.includes(i) &&
      showHideInput(input, values, undefined, undefined, setValues, `${formId}.${i}`)
  });
  let maxRepeat = 9999;
  if (typeof options[k].maxRepeat === 'string') {
    const [maxRepeatCond, trueVal] = options[k].maxRepeat.split('|');
    if (checkCondition(maxRepeatCond, values, values)) {
      maxRepeat = parseInt(trueVal);
    }
  }
  return allInputs.length ? <React.Fragment key={i}>
    {getFormTitles(formTitles, formId, i)}
    {['h2', 'h3', 'h4', 'h5', 'h6'].includes(form.inputType) ?
      getInputHeadLines(form.inputType, i, form, values)
      :
      <>
        <Form.List key={formId} name={formId}>
          {(fields, { add, remove }) => {
            const formData = form.repeatable
              ? (values[formId] || [])
              : (values[formId]
                ? [values[formId]] : []);
            if (fields.length === 0) {
              const formInputs = form.inputs
              if (formData.length && formData[0] && Object.keys(formData[0]).length) {
                formData.forEach(f => {
                  Object.keys(f).forEach(fkey => {
                    if (formInputs[fkey] && formInputs[fkey].inputType === 'total100' && !f[fkey]) {
                      f[fkey] = [{
                        type: null,
                        value: null
                      }];
                    } else if (formInputs[fkey] && ['date', 'year'].includes(formInputs[fkey].inputType)) {
                      f[fkey] = f[fkey] ? dayjs(f[fkey]) : undefined;
                    } else if (formInputs[fkey] && 'switch' === formInputs[fkey].inputType && !formInputs[fkey].optionGroup) {
                      f[fkey] = f[fkey] || false;
                    }
                  })
                  add(f);
                });
              }
            }

            const renderBefore = (currentField) => {
              return <div style={{ zIndex: -1000, position: 'fixed', top: -1000, left: -1000, }}>
                {currentField && formInputs.map((inp, ii) => {
                  const input = form.inputs[inp];
                  const inputId = input.dataId || inp;
                  const inputValues = Array.isArray(values[formId]) ? (values[formId][currentField.name] || {}) : (values[formId] || {});
                  const value = inputValues[inputId];
                  const commentValue = inputValues[`${inputId}Comment`];
                  const inputData = getData(formId, input, value, commentValue, `${formId}[${currentField.name}].${inputId}`, `${formId}.${inputId}`);
                  const subtitles = form.subtitles || null;
                  inputData.repeatIndex = currentField.name;
                  inputData.inputName = inputId;
                  inputData.repeatValues = inputValues;
                  if (inputData.groupInputs && Array.isArray(inputData.groupInputs)) {
                    inputData.groupInputs = inputData.groupInputs.map(gpI => {
                      gpI.data.inputName = gpI.data.name;
                      gpI.data.repeatIndex = currentField.name;
                      gpI.data.name = formId;
                      return gpI;
                    });
                  }
                  inputData.totalInputs = totalFormInputs;
                  shownInputs[inputId] = showHideInput(input, values, currentField.name, inputValues, setValues, `${formId}[${currentField.name}].${inputId}`);
                  inputData.shownInputs = shownInputs
                  return shownInputs[inputId] ?
                    <React.Fragment key={`${i}${ii}`}>
                      <div key={ii} className={form.repeatable
                        ? `inputs` : ""}>
                        {getSubtitles(subtitles, input.position, values, currentField.name, inputValues)}
                        {['h2', 'h3', 'h4', 'h5', 'h6'].includes(input.inputType) ?
                          getInputHeadLines(input.inputType, i, input, values)
                          :
                          <>
                            <Form.Item
                              {...currentField}
                              required={
                                inputData.rules && inputData.rules instanceof Array &&
                                  inputData.rules.filter(r => r.required).length > 0 ? true : false
                              }
                              {...(['total100', 'group'].includes(input.inputType) ? {} : {
                                name: [currentField.name, inputId],
                                fieldKey: [currentField.fieldKey, inputId],
                                initialValue: inputData.value,
                              })}
                              {...(['upload', 'imageUpload'].includes(input.inputType) ? {
                                valuePropName: "fileList",
                                getValueFromEvent: (e) => {
                                  if (Array.isArray(e)) {
                                    return e;
                                  }
                                  return e && e.fileList && e.fileList.map(f => {
                                    if (f.response) {
                                      return f.response;
                                    }
                                    return f;
                                  })
                                }
                              } : {})}
                              {...(['switch'].includes(input.inputType) ? {
                                labelCol: { span: 20 },
                                style: {
                                  ...(input.showOnView === false ? { display: 'none' } : {}),
                                  flexDirection: 'row',
                                  justifyContent: 'space-between',
                                }
                              } : {})}
                              {...(inputOnBlur.includes(input.inputType) ? { trigger: "onBlur" } : {})}
                              style={input.showOnView === false ? { display: 'none' } : {}}
                              label={input.comment ? <span><span>{getInputLabel(input, values)}</span><span>
                                <Button
                                  icon={<MessageOutlined />}
                                  className="no-ln-height comment-btn"
                                  {...(!inputData.commentValue ? {} : { danger: true })}
                                  disabled={inputData.props.disabled}
                                  type="link"
                                  onClick={() => {
                                    const inputValues = Array.isArray(values[formId])
                                      ? (values[formId][currentField.name] || {})
                                      : (values[formId] || {});
                                    inputValues[`${inputData.inputName}Comment`] =
                                      !inputData.commentValue ? '' : undefined;
                                    if (Array.isArray(values[formId])) {
                                      values[formId][currentField.name] = inputValues;
                                    } else {
                                      values[formId] = inputValues;
                                    }
                                    setValues({ ...values });
                                  }}>
                                  {i18next.t(!inputData.commentValue
                                    ? 'Add Comment' : 'Remove Comment')}
                                </Button>
                              </span></span> : getInputLabel(input, values)}
                              className={`${input.comment ? 'with-comment' : ''} i-${input.inputType} total-inputs-${totalFormInputs} ${!getInputLabel(input, values).length ? 'no-label' : ''}`}
                              data-id={inputData.inputName}>
                              {inputTypeComponent[input.inputType]
                                ? inputTypeComponent[input.inputType](inputData, {
                                  form: MainForm,
                                  forms: options,
                                  allForms: plainForms,
                                  setFormValues: setValues,
                                  remove,
                                  add,
                                  setAddress,
                                  filtersConfig: {
                                    input,
                                    formsValue: values,
                                    repeatIndex: undefined,
                                    repeatValues: inputValues,
                                    setValues,
                                    ref: `${formId}.${inputId}`
                                  },
                                  config: input,
                                }) : console.log(input)}
                            </Form.Item>
                            {input.comment && propHasValue(inputData.commentValue) ?
                              <Form.Item
                                style={{ display: !propHasValue(inputData.commentValue) ? 'none' : 'flex' }}
                                className="comment-textarea"
                                name={[currentField.name, `${inputData.inputName}Comment`]}
                                fieldKey={[currentField.fieldKey, `${inputData.inputName}Comment`]}
                                initialValue={inputData.commentValue}
                                hidden={!propHasValue(inputData.commentValue)}>
                                {inputTypeComponent.comment(inputData, {
                                  form: MainForm,
                                  forms: options,
                                  setFormValues: setValues
                                })}
                              </Form.Item> : null}
                          </>
                        }
                      </div>
                    </React.Fragment> : null
                })}
              </div>
            };

            if (form.repeatable && form.editComponent) {
              try {
                const fn = eval(form.editComponent);
                return fn(options[k], setValues, values, excludedKeys, i, formTitles, getData, MainForm, plainForms, setAddress);
              } catch (e) {
                return 'Edit component not found';
              }
            }
            const formInputs = Object.keys(form.inputs)
              .filter(i => !excludedKeys.includes(i));
            const totalFormInputs = formInputs.length;
            let shownInputs = {};
            let dataSources = fields.map(field => {
              return {
                fieldConfig: { ...field },
                ...Array.isArray(values[formId])
                  ? (values[formId][field.name] || {})
                  : (values[formId] || {}),
              };
            });
            console.log(formInputs, );
            let repeatableTableCols = formInputs
              .map(i => {
                return {
                  key: i,
                  ...form.inputs[i]
                };
              })
              .sort((a, b) => a.table - b.table)
              .map((i, iIndex) => {
                const _label = i.outputLabel || i.label;
                return {
                  key: iIndex + 1,
                  dataIndex: i.key,
                  ellipsis: true,
                  title:  <Tooltip title={_label}>{_label}</Tooltip>,
                  render: (_, item) => {
                    return <BasicInput
                      name={i.key}
                      tooltip
                      repeatable
                      valueOnly
                      config={i}
                      data={item}
                    />;
                  }
                };
              })

            if (!form.hideEditButton) {
              repeatableTableCols = repeatableTableCols.concat([
                {
                  key: 'actions',
                  title: i18next.t(' '),
                  width: 30,
                  render: (item, all) => {
                    return (
                      <MoreMenu
                        items={[
                          {
                            label: i18next.t('Edit'),
                            onClick: () => {
                              setCurrentField(item.fieldConfig);
                              setIsModalVisible(formId);
                            },
                            key: "edit",
                          },
                          {
                            label: i18next.t('Delete'),
                            onClick: () => {
                              remove(item.fieldConfig.name);
                            },
                            key: "Delete",
                            disabled: form.hideRemoveButton,
                          },
                        ]}
                      />
                    );
                  },
                },
              ]);
            }

            return <React.Fragment>
              <div className={form.repeatable ? "repeatable" : ''}>
                <div className="header">
                  <div className="main">
                    {!form.repeatable
                      ? (
                        <h3>
                          {getInputLabel(form, values)}
                        </h3>
                      ) : (!form.hideSectionLabel ? (
                        <h3>
                          {form.label ? getInputLabel(form, values) : camelCaseToTitle(k)}
                        </h3>
                      ) : null)}
                  </div>
                  <div>
                    {form.repeatable && !form.hideAddButton && fields.length < (maxRepeat - 1)
                      ? (<Button
                        type="primary"
                        className="mt-2"
                        style={{ borderRadius: '2px' }}
                        size="small"
                        block
                        onClick={() => {
                          // add({});
                          setIsModalVisible(formId);
                          setCurrentField({
                            name: fields.length,
                            key: fields.length,
                            isListField: true,
                            fieldKey: fields.length,
                          });
                        }}>

                        <PlusCircleOutlined />
                        {i18next.t('Add')}
                      </Button>
                      ) : null}
                  </div>
                </div>
                <div className="table-body">
                  <div className='daf-table-wrapper no-pagination extra-small small-body small-head'>
                    <Table
                      locale={getLocales(i18next.t)}
                      size="small"
                      pagination={false}
                      bordered
                      columns={[
                        {
                          title: 'No.',
                          dataIndex: 'NO',
                          key: 'number',
                          render: (a, b, i) => (
                            <div className="input">
                              <p className="value" style={{ textAlign: 'center' }}>{i + 1}</p>
                            </div>
                          ),
                          width: 60,
                        },
                        ...repeatableTableCols,
                      ]}
                      dataSource={dataSources.filter((source, i) => {
                        const isEmpty = Object.keys(source).filter(key => key !== 'fieldConfig')
                          .map(key => propHasValue(source[key]))
                          .every(key => !key);
                        return !isEmpty;
                      })}
                    >
                    </Table>
                  </div>
                </div>
                <Modal
                  open={isModalVisible === formId}
                  className="editdd-table-modal"
                  footer={null}
                  destroyOnClose={form.dontDestroyOnClose ? false : true}
                  onCancel={() => {
                    setCurrentField(null);
                    setIsModalVisible(null);
                    dataSources.forEach(source => {
                      const isEmpty = Object.keys(source).filter(key => key !== 'fieldConfig')
                        .map(key => propHasValue(source[key])).every(key => !key);
                      if (isEmpty) {
                        remove(source.fieldConfig.name);
                      }
                    });
                  }}
                  title={(
                    <ModalHeader
                      title={form.repeatLabel || i18next.t('Add Data')}
                      supportText={typeof form.sectionLabel === 'string' ? form.sectionLabel : null}
                    />
                  )}
                >
                  {currentField && formInputs.map((inp, ii) => {
                    const input = form.inputs[inp];
                    const inputId = input.dataId || inp;
                    const inputValues = Array.isArray(values[formId]) ? (values[formId][currentField.name] || {}) : (values[formId] || {});
                    const value = inputValues[inputId];
                    const commentValue = inputValues[`${inputId}Comment`];
                    const inputData = getData(formId, input, value, commentValue, `${formId}[${currentField.name}].${inputId}`, `${formId}.${inputId}`);
                    const subtitles = form.subtitles || null;
                    inputData.repeatIndex = currentField.name;
                    inputData.inputName = inputId;
                    inputData.repeatValues = inputValues;
                    if (inputData.groupInputs && Array.isArray(inputData.groupInputs)) {
                      inputData.groupInputs = inputData.groupInputs.map(gpI => {
                        gpI.data.inputName = gpI.data.name;
                        gpI.data.repeatIndex = currentField.name;
                        gpI.data.name = formId;
                        return gpI;
                      });
                    }
                    inputData.totalInputs = totalFormInputs;
                    shownInputs[inputId] = showHideInput(input, values, currentField.name, inputValues, setValues, `${formId}[${currentField.name}].${inputId}`);
                    inputData.shownInputs = shownInputs
                    return shownInputs[inputId] ?
                      <React.Fragment key={`${i}${ii}`}>
                        <div key={ii} className={form.repeatable
                          ? `inputs` : ""}>
                          {getSubtitles(subtitles, input.position, values, currentField.name, inputValues)}
                          {['h2', 'h3', 'h4', 'h5', 'h6'].includes(input.inputType) ?
                            getInputHeadLines(input.inputType, i, input, values)
                            :
                            <>
                              <Form.Item
                                rules={inputData.rules}
                                required={
                                  inputData.rules && inputData.rules instanceof Array &&
                                    inputData.rules.filter(r => r.required).length > 0 ? true : false
                                }
                                {...(['total100', 'group'].includes(input.inputType) ? {} : {
                                  name: [currentField.name, inputId],
                                  fieldKey: [currentField.fieldKey, inputId],
                                  initialValue: inputData.value,
                                })}
                                {...(['upload', 'imageUpload'].includes(input.inputType) ? {
                                  valuePropName: "fileList",
                                  getValueFromEvent: (e) => {
                                    if (Array.isArray(e)) {
                                      return e;
                                    }
                                    return e && e.fileList && e.fileList.map(f => {
                                      if (f.response) {
                                        return f.response;
                                      }
                                      return f;
                                    })
                                  }
                                } : {})}
                                {...(['switch'].includes(input.inputType) ? {
                                  labelCol: { span: 20 },
                                  style: {
                                    ...(input.showOnView === false ? { display: 'none' } : {}),
                                    flexDirection: 'row',
                                    justifyContent: 'space-between',
                                  }
                                } : {})}
                                {...(inputOnBlur.includes(input.inputType) ? { trigger: "onBlur" } : {})}
                                style={input.showOnView === false ? { display: 'none' } : {}}
                                label={input.comment ? <span><span>{getInputLabel(input, values)}</span><span>
                                  <Button
                                    icon={<MessageOutlined />}
                                    className="no-ln-height comment-btn"
                                    {...(!inputData.commentValue ? {} : { danger: true })}
                                    disabled={inputData.props.disabled}
                                    type="link"
                                    onClick={() => {
                                      const inputValues = Array.isArray(values[formId])
                                        ? (values[formId][currentField.name] || {})
                                        : (values[formId] || {});
                                      inputValues[`${inputData.inputName}Comment`] =
                                        !inputData.commentValue ? '' : undefined;
                                      if (Array.isArray(values[formId])) {
                                        values[formId][currentField.name] = inputValues;
                                      } else {
                                        values[formId] = inputValues;
                                      }
                                      setValues({ ...values });
                                    }}>
                                    {i18next.t(!inputData.commentValue
                                      ? 'Add Comment' : 'Remove Comment')}
                                  </Button>
                                </span></span> : getInputLabel(input, values)}
                                className={`${input.comment ? 'with-comment' : ''} i-${input.inputType} total-inputs-${totalFormInputs} ${!getInputLabel(input, values).length ? 'no-label' : ''}`}
                                data-id={inputData.inputName}>
                                {inputTypeComponent[input.inputType]
                                  ? inputTypeComponent[input.inputType](inputData, {
                                    form: MainForm,
                                    forms: options,
                                    allForms: plainForms,
                                    setFormValues: setValues,
                                    remove,
                                    add,
                                    setAddress,
                                    filtersConfig: {
                                      input,
                                      formsValue: values,
                                      repeatIndex: undefined,
                                      repeatValues: inputValues,
                                      setValues,
                                      ref: `${formId}.${inputId}`
                                    },
                                    config: input,
                                  }) : console.log(input)}
                              </Form.Item>
                              {input.comment && propHasValue(inputData.commentValue) ?
                                <Form.Item
                                  style={{ display: !propHasValue(inputData.commentValue) ? 'none' : 'flex' }}
                                  className="comment-textarea"
                                  name={[currentField.name, `${inputData.inputName}Comment`]}
                                  fieldKey={[currentField.fieldKey, `${inputData.inputName}Comment`]}
                                  initialValue={inputData.commentValue}
                                  hidden={!propHasValue(inputData.commentValue)}>
                                  {inputTypeComponent.comment(inputData, {
                                    form: MainForm,
                                    forms: options,
                                    setFormValues: setValues
                                  })}
                                </Form.Item> : null}
                            </>
                          }
                        </div>
                      </React.Fragment> : null
                  })}
                  <div className="repeatable-modal-actions">
                    <Button onClick={() => {
                      dataSources.forEach(source => {
                        const isEmpty = Object.keys(source).filter(key => key !== 'fieldConfig')
                          .map(key => propHasValue(source[key])).every(key => !key);
                        if (isEmpty) {
                          remove(source.fieldConfig.name);
                        }
                      });
                      setIsModalVisible(null);
                    }}>{i18next.t('Cancel')}</Button>
                    <Button type="primary" onClick={() => {
                      setIsModalVisible(null);
                    }}>{i18next.t('Add')}</Button>
                  </div>
                </Modal>
              </div>
            </React.Fragment>
          }}
        </Form.List>
      </>
    }
  </React.Fragment > : null

}

export function renderGroupOfInputs(options, k, setValues, values, excludedKeys, i, formTitles, getData, MainForm, plainForms, setAddress) {
  const form = options[k];
  const formId = form.dataId || k;
  const allInputs = Object.keys(form.inputs).filter(i => !excludedKeys.includes(i));

  return allInputs.length ? <React.Fragment key={i}>
    {getFormTitles(formTitles, formId, i)}
    {['h2', 'h3', 'h4', 'h5', 'h6'].includes(form.inputType) ?
      getInputHeadLines(form.inputType, i, form, values)
      :
      getGroupContent(form, values, i, formId, excludedKeys, getData, setValues, MainForm, options, plainForms, setAddress)
    }
  </React.Fragment> : null
}

const getGroupContent = (form, values, i, formId, excludedKeys, getData, setValues, MainForm, options, plainForms, setAddress) => {
  const label = getInputLabel(form, values);
  const hasLabel = label && ((typeof label === 'string' && (label || '').trim() !== '') || typeof label === 'object') ? true : false;

  return <>
    {hasLabel ? (
      <h3
        className={`${form.titleClass ? form.titleClass : 'title-normal-2'} ${i ? 'mt-3 mb-1' : ''}`}>
        {label}
      </h3>
    ) : null}
    <div className={`repeatable ${hasLabel ? "mb-2" : ""}`}>
      {form.titleLabel ? <label>{getInputProp(form.titleLabel, values)}</label> : null}
      {Object.keys(form.inputs)
        .filter(i => !excludedKeys.includes(i))
        .map((inp, ii) => {
          const input = form.inputs[inp];
          const inputId = input.dataId || inp;
          const inputValues = Array.isArray(values[formId]) ? (values[formId] || {}) : (values[formId] || {});
          const value = inputValues[inputId];
          const commentValue = inputValues[`${inputId}Comment`];
          const inputData = getData(formId, input, value, commentValue, `${formId}.${inputId}`, `${formId}.${inputId}`);
          const subtitles = form.subtitles || null;
          inputData.repeatIndex = undefined;
          inputData.inputName = inputId;
          inputData.repeatValues = inputValues;
          if (inputData.groupInputs && Array.isArray(inputData.groupInputs)) {
            inputData.groupInputs = inputData.groupInputs.map(gpI => {
              gpI.data.inputName = gpI.data.name;
              gpI.data.repeatIndex = undefined;
              gpI.data.name = formId;
              return gpI;
            });
          }
          const rules = inputData.rules
            ? inputData.rules.filter(rule => !Object.keys(rule).includes('accept') && !Object.keys(rule).includes('max'))
            : []

          const requiredRule = rules.find((r) => r.required);

          if (requiredRule && input.inputType === 'text') {
            rules.push({ whitespace: true, message: requiredRule.message || '' });
          }

          return showHideInput(input, values, undefined, inputValues, setValues, `${formId}.${inputId}`) ?
            <React.Fragment key={`${i}${ii}`}>
              <div key={ii}>
                {getSubtitles(subtitles, input.position, values, undefined, inputValues)}
                {['h2', 'h3', 'h4', 'h5', 'h6'].includes(input.inputType) ?
                  getInputHeadLines(input.inputType, i, input, values)
                  :
                  <>
                    <Form.Item
                      required={
                        inputData.rules && inputData.rules instanceof Array &&
                          inputData.rules.filter(r => r.required).length > 0 ? true : false
                      }
                      {...(['total100', 'group'].includes(input.inputType) ? {} : {
                        name: [formId, inputId],
                        fieldKey: [formId, inputId],
                        initialValue: inputData.value,
                      })}
                      {...(['upload', 'imageUpload'].includes(input.inputType) ? {
                        valuePropName: "fileList",
                        getValueFromEvent: (e) => {
                          if (Array.isArray(e)) {
                            return e;
                          }
                          return e && e.fileList && e.fileList.map(f => {
                            if (f.response) {
                              return f.response;
                            }
                            return f;
                          })
                        }
                      } : {})}
                      {...(inputOnBlur.includes(input.inputType) ? { trigger: "onBlur" } : {})}
                      style={input.showOnView === false ? { display: 'none' } : {}}
                      {...(['switch'].includes(input.inputType) ? {
                        labelCol: { span: 20 },
                        style: {
                          ...(input.showOnView === false ? { display: 'none' } : {}),
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                        }
                      } : {})}
                      label={input.comment ?
                        (<span>
                          <span>
                            {getInputLabel(input, values)}
                          </span>
                          {!input.commentShown ? <span>
                            <Button
                              icon={<MessageOutlined />}
                              className="no-ln-height comment-btn"
                              {...(!inputData.commentValue ? {} : { danger: true })}
                              disabled={inputData.props.disabled}
                              type="link"
                              onClick={() => {
                                const inputValues = Array.isArray(values[formId])
                                  ? (values[formId] || {})
                                  : (values[formId] || {});
                                inputValues[`${inputData.inputName}Comment`] =
                                  !inputData.commentValue ? '' : undefined;
                                if (Array.isArray(values[formId])) {
                                  values[formId] = inputValues;
                                } else {
                                  values[formId] = inputValues;
                                }
                                setValues({ ...values });
                              }}>
                              {i18next.t(!inputData.commentValue
                                ? 'Add Comment' : 'Remove Comment')}
                            </Button>
                          </span> : null}
                        </span>) : getInputLabel(input, values)}
                      rules={rules}
                      className={input.comment
                        ? `with-comment i-${input.inputType} ${input.showOnTitle ? 'onTitle' : ''} ${!getInputLabel(input, values).length ? 'no-label' : ''}`
                        : `i-${input.inputType} ${input.showOnTitle ? 'onTitle' : ''} ${!getInputLabel(input, values).length ? 'no-label' : ''}`}
                      data-id={inputData.inputName}>

                      {inputTypeComponent[input.inputType]
                        ? inputTypeComponent[input.inputType](inputData, {
                          form: MainForm,
                          forms: options,
                          allForms: plainForms,
                          setFormValues: setValues,
                          setAddress,
                          config: input,
                          filtersConfig: {
                            input,
                            formsValue: values,
                            repeatIndex: undefined,
                            repeatValues: inputValues,
                            setValues,
                            ref: `${formId}.${inputId}`
                          }
                        }) : console.log(input)}
                    </Form.Item>
                    {input.comment ?
                      <Form.Item
                        label={input.commentLabel}
                        className="comment-textarea"
                        name={[formId, `${inputData.inputName}Comment`]}
                        fieldKey={[formId, `${inputData.inputName}Comment`]}
                        initialValue={inputData.commentValue}
                        hidden={!inputData.commentValue ? !input.commentShown : false}>
                        {inputTypeComponent.comment(inputData, {
                          form: MainForm,
                          forms: options,
                          setFormValues: setValues
                        })}
                      </Form.Item> : null}
                  </>
                }
              </div>
            </React.Fragment> : null
        })}
    </div>
  </>
}
